import type { BlockViewProps } from '@plone/types';
import { useLocation } from 'react-router-dom';
import type {
  BCDescriptionTitleData,
  BowlingCenterContent,
} from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterDescription/schema';
import BowlingCenterHeader from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterHeader/bowlingcenterheader';
import SearchNavigation from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterHeader/searchNavigation';
import { getBowlingCenterSearch } from '@redturtle/qubicaamf-theme/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

type Props = BlockViewProps & {
  data: BCDescriptionTitleData;
  properties: BowlingCenterContent;
};
export default function View({ data, properties, className, style }: Props) {
  // const has_query = true;
  const { search } = useLocation();
  // @ts-expect-error
  const navigation = useSelector((store) => store.bowlingcentersearch);
  const dispatch = useDispatch();
  const currentUID = properties.UID;
  useEffect(() => {
    dispatch(getBowlingCenterSearch(search, currentUID));
  }, [dispatch, search]);
  return (
    <div>
      {search && <SearchNavigation navigation={navigation} />}
      <BowlingCenterHeader
        parent={properties.parent}
        lanesnr={properties.lanesnr}
        region={properties.bowling_center_region}
      />
    </div>
  );
}
